module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordDetail/images/facebook.6393609de5af68e1d24aed529111cf73.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordDetail/images/facebook.svg
// module id = 1668
// module chunks = 1